import { ApiClientBase } from "./ApiClientBase";

export interface Recipient {
    id?: number;
    transport: MessageTransportType;
    userId?: number;
    contact: string;
}

export enum MessageTransportType {
    //    Unknown = "Unknown",
    Sms = "Sms",
    Email = "Email",
    Telegram = "Telegram",
    //Web = 4
}

export interface Message {
    recipients: Recipient[];
    subject: string;
    body: string;
    source?: string;
    metadata?: string;
}

export interface SendMessageResult {
    deliveryResults: DeliveryResult[];
}
export interface DeliveryResult {
    recipient: Recipient;
    deliveryStatus: DeliveryStatus;
    error: string;
    sendDuration: number;
}

export enum DeliveryStatus {
    Error = -1,
    Unknown = 0,
    Delivered = 1,
    Queued = 2,
}

class SendService extends ApiClientBase {
    constructor() {
        super("/api/Send/");
    }

    public TestMessage(msg: Message): Promise<SendMessageResult> {
        var form = new FormData();
        form.append("message", JSON.stringify(msg));
        return this.request({
            url: this.buildUrl("TestMessage"),
            method: "POST",
            data: form,
            headers: { "Content-Type": "multipart/form-data" },
        });
    }
}

export const sendService = new SendService();
